export enum SupportDialogEvents {
  Updated = 'SupportDialogUpdated',
}
